import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchQueryFiltersService} from '../../../../@backend/modules/@filters/torch-query-filters.service';
import {QueryFilterDialogComponent} from './components/query-filter-dialog/query-filter-dialog.component';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {QueryFilterDialogService} from './services/query-filter-dialog.service';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgxPermissionsModule} from 'ngx-permissions';
import {MatTooltipModule} from '@angular/material/tooltip';

// eslint-disable-next-line max-len
import {QueryFilterEditComponent} from './components/query-filter-dialog/dialog-components/query-filter-edit/query-filter-edit.component';
// eslint-disable-next-line max-len
import {QueryFilterActionsComponent} from './components/query-filter-dialog/dialog-components/query-filter-actions/query-filter-actions.component';
import {MatMenuModule} from '@angular/material/menu';
import {NgxFileDropModule} from 'ngx-file-drop';

@NgModule({
  declarations: [
    QueryFilterDialogComponent,
    QueryFilterActionsComponent,
    QueryFilterEditComponent
  ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatToolbarModule,
        FlexLayoutModule,
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule,
        ScrollingModule,
        MatProgressSpinnerModule,
        NgxPermissionsModule,
        MatTooltipModule,
        MatMenuModule,
        NgxFileDropModule
    ],
  providers: [
    TorchQueryFiltersService,
    MatDialog,
    QueryFilterDialogService
  ]
})
export class QueryFiltersModule {
}
